import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const NoteCardSkeletonLoader = ({
  shouldEnableAnimation = false,
  skeletonHeight = 16,
  skeletonTopBarHeight = 8,
  skeletonSiteNameWidth = '70%',
  skeletonStatusLabelWidth = '18%',
  skeletonStatusValueWidth = '25%',
  skeletonTitleWidth = '60%',
  skeletonDateWidth = '30%',
  skeletonContentFirstLineWidth = '100%',
  skeletonContentMiddleLineWidth = '90%',
  skeletonContentLastLineWidth = '70%',
}) => {
  return (
    <div className="rounded-10px bg-vamos-white text-lg text-left font-sans overflow-hidden shadow-md w-full">
      {/* Top priority bar */}
      <Skeleton
        height={skeletonTopBarHeight}
        width="100%"
        enableAnimation={shouldEnableAnimation}
      />

      {/* Site name and status */}
      <div className="px-6 py-3">
        {/* Site name */}
        <div className="h-14 overflow-hidden mb-1">
          <Skeleton
            height={skeletonHeight + 4}
            width={skeletonSiteNameWidth}
            enableAnimation={shouldEnableAnimation}
          />
        </div>

        {/* Status row */}
        <div className="flex items-center mt-1 gap-2">
          <Skeleton
            height={skeletonHeight - 2}
            width={skeletonStatusLabelWidth}
            enableAnimation={shouldEnableAnimation}
          />
          <Skeleton
            height={skeletonHeight - 2}
            width={skeletonStatusValueWidth}
            enableAnimation={shouldEnableAnimation}
          />
        </div>
      </div>

      {/* Title, date, and content */}
      <div className="border-t-2 px-6 py-3 h-2/3">
        {/* Title and date row */}
        <div className="flex justify-between items-center mb-2 gap-4">
          <Skeleton
            height={skeletonHeight}
            width={skeletonTitleWidth}
            enableAnimation={shouldEnableAnimation}
          />
          <Skeleton
            height={skeletonHeight - 2}
            width={skeletonDateWidth}
            enableAnimation={shouldEnableAnimation}
          />
        </div>

        {/* Content lines */}
        <div className="space-y-2">
          <Skeleton
            height={skeletonHeight}
            width={skeletonContentFirstLineWidth}
            enableAnimation={shouldEnableAnimation}
          />
          <Skeleton
            height={skeletonHeight}
            width={skeletonContentMiddleLineWidth}
            enableAnimation={shouldEnableAnimation}
          />
          <Skeleton
            height={skeletonHeight}
            width={skeletonContentMiddleLineWidth}
            enableAnimation={shouldEnableAnimation}
          />
          <Skeleton
            height={skeletonHeight}
            width={skeletonContentLastLineWidth}
            enableAnimation={shouldEnableAnimation}
          />
        </div>
      </div>
    </div>
  );
};

NoteCardSkeletonLoader.propTypes = {
  shouldEnableAnimation: PropTypes.bool,
  skeletonHeight: PropTypes.number,
  skeletonTopBarHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonSiteNameWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonStatusLabelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonStatusValueWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonTitleWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonDateWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonContentFirstLineWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonContentMiddleLineWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonContentLastLineWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default NoteCardSkeletonLoader;
